<script setup>
import { ref, defineProps, defineEmits, computed } from "vue";
import Select2 from "@/components/frontend/ui/Select2.vue";
import { dinParts } from "@nineteen-2/dtc-registration-form";
import { FIELDS } from "@nineteen-2/dtc-din";
import Tooltip from "@/components/frontend/ui/Tooltip.vue";

const props = defineProps({
  disabled: { type : Boolean, default: false},
  registration: { type : Object, required: true},
  field: { type : Object},
  errors: { type : Object}
})

const emits = defineEmits(['input'])

const onConfigChange = (key, value) => {
  emits("input", {
    [key]: value
  });
}

// The skier's inputs: the recommended and selected settings are shown by DinValue.
const fields = computed(() => {
  const { [FIELDS.RECOMMENDED]: recommended, [FIELDS.SELECTED]: selected, ...inputs } = dinParts(props.field)

  return inputs
})

</script>
<template>
  <div class="row">
    <template v-for="field in fields">
      <div class="form-group col-md-6" :class="{ 'has-danger has-error': props.errors[field.key] }">
        <label :for="'registration_' + field.key">
          {{ field.templateOptions.label }}
          <small v-if="field.templateOptions.required" class="align-middle font-weight-bold text-danger">*</small>
          <Tooltip v-if="field.templateOptions.tooltip" :title="field.templateOptions.tooltip" class="ml-2">
            <i class="fa fa-question-circle"></i>
          </Tooltip>
        </label>
        <template v-if="field.type === 'select'">
          <Select2 :id="'registration_' + field.key"
                   :model-value="props.registration[field.key]"
                   @update:model-value="onConfigChange(field.key, $event)"
                   :disabled="disabled"
                   :options="field.templateOptions.options.map(o => ({'id': o.value, 'text':  o.name}))"
                   class="form-control" style="width: 100%" v-cloak>
          </Select2>
        </template>
        <template v-else-if="field.type === 'input'">
          <input :type="field.templateOptions?.type ?? 'text'"
                 :id="'registration_' + field.key"
                 :value="props.registration[field.key]"
                 v-on:input="onConfigChange(field.key, $event.target.value)"
                 :class="[
                   'form-control',
                 ]"
          />
        </template>
        <div class="invalid-feedback d-block" v-if="props.errors[field.key]" v-cloak>
          {{ props.errors[field.key][0] }}
        </div>
      </div>
    </template>
  </div>
</template>